module.exports = __webpack_public_path__ + "img/play_VR.001c0f6d.png";